export default "/logo_white.541acafd-af7f9b.png";